
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, SimpleChanges, ViewChild, output } from "@angular/core";
import { PopperHelper } from "@nts/std/utility";
import { NgxPopperjsDirective, NgxPopperjsModule, NgxPopperjsPlacements, NgxPopperjsTriggers } from "ngx-popperjs";

let nextId = 0;

@Component({
    selector: 'nts-base-toggle-text-box',
    templateUrl: './base-toggle-text-box.component.html',
    styleUrls: ['./base-toggle-text-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    NgxPopperjsModule
]
})
export class BaseToggleTextBoxComponent implements AfterViewInit {
    @Input() label = '';
    @Input() tabIndex = -1;
    @Input() isDisabled = false;
    @Input() checkStatus = false;
    @Input() customClasses = '';
    @Input() errorList: string[] = [];
    @Input() showErrorTooltip = true;
    @Input() showTitleTooltip = true;
    @Input() showErrorBorder = true;
    @Input() labelText: string;
    @Input() showLabelText = true;
    @Input() primaryColor = null;
    @Input() isReadOnly = false;

    @Output() onChange = new EventEmitter<boolean>();
    @Output() onClick = new EventEmitter<void>();
    readonly viewReady = output<void>();
    isViewReady = false;

    @ViewChild('toggleBox', { static: true }) toggleBox: ElementRef;
    @ViewChild('popperInfo', { static: false }) popperInfo: NgxPopperjsDirective;
    @ViewChild('popperError', { static: false }) popperError: NgxPopperjsDirective;

    id = `tog-${nextId++}`;
    ngxPopperjsTriggers = NgxPopperjsTriggers;
    ngxPopperjsPlacements = NgxPopperjsPlacements;

    get input() {
        return this.toggleBox.nativeElement;
    }

    constructor(protected cd: ChangeDetectorRef) { }

    ngAfterViewInit(): void {
        queueMicrotask(() => this.emitViewReady());
    }

    private emitViewReady(): void {
        this.isViewReady = true;
        this.viewReady.emit();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['errorList']) {
            this.checkPopper();
        }
    }

    keydownSpace(e: any): void {
        if (!this.isDisabled && !this.isReadOnly) {
            e.preventDefault();
            e.stopPropagation();
            this.toggleValue();
        } else {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    click(e: any): void {
        if (!this.isDisabled && !this.isReadOnly) {
            e.preventDefault();
            e.stopPropagation();
            this.toggleValue();
        } else {
            e.preventDefault();
            e.stopPropagation();
        }
        this.onClick.emit();
    }

    toggleValue(): void {
        if (!this.isDisabled && !this.isReadOnly) {
            this.checkStatus = !this.checkStatus;
            this.toggleBox.nativeElement.checked = this.checkStatus;
            this.onChange.emit(this.checkStatus);
            this.cd.detectChanges();
        }
    }

    private checkPopper() {
        if (this.popperError && (this.errorList == null || this.errorList.length === 0)) {
            PopperHelper.hide(this.popperError);
        }
        if (this.popperInfo && this.errorList?.length > 0) {
            PopperHelper.hide(this.popperInfo);
        }
    }
}
